import React, { useState, useEffect } from 'react';

const PriceRangeSlider = ({
  min = 0,
  max = 100,
  step = 1,
  value = { min: 0, max: 100 },
  onChange,
  formatLabel = (val) => val
}) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleMinChange = (e) => {
    const newMin = Math.min(Number(e.target.value), localValue.max - step);
    const newValue = { ...localValue, min: newMin };
    setLocalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleMaxChange = (e) => {
    const newMax = Math.max(Number(e.target.value), localValue.min + step);
    const newValue = { ...localValue, max: newMax };
    setLocalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const minPercent = ((localValue.min - min) / (max - min)) * 100;
  const maxPercent = ((localValue.max - min) / (max - min)) * 100;
  const thumbColor = '#000000';

  return (
    <div className="w-full price-range-slider">
      <style>{`
        .price-range-slider input[type="range"]::-webkit-slider-thumb {
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: ${thumbColor};
          cursor: pointer;
          border: 2px solid #fff;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        }
        .price-range-slider input[type="range"]::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: ${thumbColor};
          cursor: pointer;
          border: 2px solid #fff;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        }
      `}</style>
      <div className="relative h-2 bg-gray-200 rounded-lg">
        <div
          className="absolute h-2 rounded-lg"
          style={{
            left: `${minPercent}%`,
            width: `${maxPercent - minPercent}%`,
            backgroundColor: 'black'
          }}
        />
      </div>
      <div className="flex items-center justify-between mt-4 space-x-4">
        <div className="flex-1">
          <label className="block text-xs text-gray-600 mb-1">Min</label>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={localValue.min}
            onChange={handleMinChange}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            style={{
              background: `linear-gradient(to right, black 0%, black ${minPercent}%, #e5e7eb ${minPercent}%, #e5e7eb 100%)`
            }}
          />
          <div className="text-sm font-medium text-gray-900 mt-1">
            {formatLabel(localValue.min)}
          </div>
        </div>
        <div className="flex-1">
          <label className="block text-xs text-gray-600 mb-1">Max</label>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={localValue.max}
            onChange={handleMaxChange}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            style={{
              background: `linear-gradient(to right, #e5e7eb 0%, #e5e7eb ${maxPercent}%, black ${maxPercent}%, black 100%)`
            }}
          />
          <div className="text-sm font-medium text-gray-900 mt-1">
            {formatLabel(localValue.max)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceRangeSlider;
